import './style.css'
import { createRoot } from 'react-dom/client'
import App from './app/App'
import { StrictMode } from 'react'
import { ErrorBoundary } from './core/ErrorBoundary'
import { LandscapeShield } from './core/LandscapeShield'

createRoot(document.querySelector('#root')).render(
  <StrictMode>
    <ErrorBoundary>
      <LandscapeShield>
        <App />
      </LandscapeShield>
    </ErrorBoundary>
  </StrictMode>
)